import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { injectTranslate } from '@core/i18n-legacy';
import { AssignMembersToJobsDialogResult } from '@core/tellent-assign-members-to-jobs-types';
import { DialogService, DialogWidth, RtPlatform } from '@core/user-interface-legacy';

import { AssignMembersToJobsDialogComponent } from './assign-members-to-jobs-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AssignMembersToJobsService {
  private readonly dialogService = inject(DialogService);
  private readonly platform = inject(RtPlatform);
  private readonly t = injectTranslate();

  public openAssignMembersDialog(dialogData: any): Observable<AssignMembersToJobsDialogResult> {
    return this.dialogService.openDialog(AssignMembersToJobsDialogComponent, dialogData, {
      width: DialogWidth.Small,
      mobileOptions: this.platform.IS_MOBILE
        ? {
            mobileDialog: true,
            mobileViewTitle: this.t('tlc.assign_members_to_jobs.dialog.mobile_heading'),
          }
        : undefined,
    }).afterClosed;
  }
}
